import React from 'react';

export default class TrueFalse extends React.PureComponent {
  constructor(props){
    super(props);

    this.setAnswer = this.setAnswer.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  derivedCorrectAnswer() {
    switch (this.props.correctAnswer) {
    case 'A':
    case 'a':
      return 'True';
    case 'B':
    case 'b':
      return 'False';
    default:
      return undefined;
    }
  }

  handleKeyUp(e){
    this.setAnswer(String.fromCharCode(e.keyCode), true);
    this.props.handleKeyUp(e);
  }

  setAnswer(answer){
    this.props.updateItem({answer: answer});
  }

  render(){
    const isAnswer = val => (this.props.answer === val);
    const isCorrectAnswer = val => (this.derivedCorrectAnswer() === val);
    const hasCorrectAnswer = this.props.teacherView && this.props.correctAnswer != undefined;

    let selfClasses = ['choices'];
    if (hasCorrectAnswer)  selfClasses.push('has-correct-answer');
    if ((this.props.answer || '').length > 0)  selfClasses.push('answered');

    const span_content = this.props.answer_options.map((answer_opt, i) => {
      let classes = ['choice'];
      let bubble_label = answer_opt;
      if (isAnswer(answer_opt))  classes.push('active');
      if (isCorrectAnswer(answer_opt))  classes.push('correct-answer');
      if (this.props.itemDisabled)  classes.push('manually-disabled');

      if (this.props.teacherView) {
        classes.push('small');
      } else {
        bubble_label = answer_opt[0];
      }

      const tap_f = e => this.setAnswer(answer_opt);

      if (this.props.teacherView) {
        return <div key={answer_opt} className={classes.join(' ')} onClick={tap_f}>{bubble_label}</div>;
      } else {
        return <React.Fragment key={answer_opt}>
                 <div className={classes.join(' ')} onClick={tap_f}>{bubble_label}</div>
                 <label onClick={tap_f}>{answer_opt}</label>
               </React.Fragment>;
      }
    });

    return (
        <div className={selfClasses.join(' ')}>
          {span_content}
        </div>
    );
  }

}
